import { createEmptyGrid } from "features/transient-response/schedules/lib/scheduleHeatmap";
import { DAY_KEYS, type DayKey, HOUR_KEYS, type ScheduleGrid } from "features/transient-response/schedules/model/types";

import type { RoomScheduleUsageHours } from "../model/scheduleTypes";

const WORKING_WEEKDAYS = new Set<DayKey>(["fri", "mon", "thu", "tue", "wed"]);

const fillGrid = (getValue: (day: DayKey, hour: number) => number): ScheduleGrid => {
  const grid = createEmptyGrid();

  DAY_KEYS.forEach((day) => {
    grid[day] = HOUR_KEYS.map((hour) => getValue(day, hour));
  });

  return grid;
};

export const createEmptyScheduleGrid = (): ScheduleGrid => createEmptyGrid();

export const createZeroScheduleGrid = (): ScheduleGrid => fillGrid(() => 0);

export const cloneScheduleGrid = (grid: ScheduleGrid): ScheduleGrid => structuredClone(grid);

export const isScheduleGridPopulated = (grid: ScheduleGrid): boolean =>
  DAY_KEYS.some((day) => grid[day].some((value) => value != null));

export const createDinScheduleGrid = (usage: RoomScheduleUsageHours): ScheduleGrid =>
  fillGrid((day, hour) => {
    const isWorkHour = hour >= usage.usageStartHour && hour <= usage.usageEndHour;
    const isWorkDay =
      WORKING_WEEKDAYS.has(day) || (day === "sat" && usage.usageSaturday) || (day === "sun" && usage.usageSunday);
    // Holiday is left as non-working until the rule is defined.
    return isWorkDay && isWorkHour ? 1 : 0;
  });

// Previous dummy realistic grid. Realistic values now come from /roomconfigtab/schedules/{kind}/.
// export const createRealisticScheduleGrid = (): ScheduleGrid => { ... };
